import { apiRequest } from './api';

export const getUserPreferences = (workspaceId) => {
  return apiRequest(`/me/preferences?workspace_id=${encodeURIComponent(workspaceId)}`);
};

export const updateUserPreferences = (workspaceId, preferences) => {
  return apiRequest(`/me/preferences?workspace_id=${encodeURIComponent(workspaceId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ preferences }),
  });
};
